import React from "react";
import { Link } from "react-router-dom";
import logoImage from "../../Image/kialogo.png";
import centralLogo from "../../Image/download.jpg";
import "./Footer.css";

const cars = [
  { name: "All New Seltos", link: "/newseltos" },
  { name: "Sonet",          link: "/sonet" },
  { name: "Carens",         link: "/carens" },
  { name: "EV6",            link: "/ev6" },
  { name: "Carnival",       link: "/carnival" },
  { name: "EV9",            link: "/ev9" },
  { name: "Syros",          link: "/syros" },
  { name: "Sorento",        link: "/sorento" },
  { name: "Carens Clavis",  link: "/carens-clavis" },
  { name: "Carens ClavisEV",link: "/carens-clavis-ev" },
];

const menus = [
  { name: "Pre-owned Cars", link: "/preowned" },
  { name: "Book Now",       link: "/" },
  { name: "Service",        link: "/service" },
  { name: "Contact Us",     link: "/contact" },
  { name: "About Us",       link: "/about" },
  { name: "Career",         link: "/" },
];

const forms = [
  { name: "Enquiry",                    link: "/enquiry" },
  { name: "Get Quotation",              link: "/quotations" },
  { name: "Test Drive",                 link: "/test-drive" },
  { name: "Service Appointment",        link: "/service" },
];

const services = [
  { name: "Book Service Appointment",   link: "/service" },
  { name: "Pre-owned Cars",             link: "/preowned" },
  { name: "Service & Maintenance",      link: "/service" },
  { name: "Service Offerings",          link: "/service" },
  { name: "Customer Awareness",         link: "/" },
  { name: "EV Owners",                  link: "/" },
];

const legal = [
  { name: "Contact Us",          link: "/contact" },
  { name: "About Us",            link: "/about" },
  { name: "Privacy Policy",      link: "/privacy-policy" },
  { name: "Terms & Conditions",  link: "/terms-and-conditions" },
];

const socials = [
  { label: "Facebook",  env: "REACT_APP_FACEBOOK_URL",  icon: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
  )},
  { label: "Instagram", env: "REACT_APP_INSTAGRAM_URL", icon: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/></svg>
  )},
  { label: "LinkedIn",  env: "REACT_APP_LINKEDIN_URL",  icon: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6zM2 9h4v12H2z"/><circle cx="4" cy="4" r="2"/></svg>
  )},
  { label: "YouTube",   env: "REACT_APP_YOUTUBE_URL",   icon: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46A2.78 2.78 0 0 0 1.46 6.42 29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58 2.78 2.78 0 0 0 1.95 1.96C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 0 0 1.96-1.96A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z"/><polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02" fill="#000"/></svg>
  )},
];

const Footer = () => (
  <footer className="ft-root">

    {/* ── TOP BAR ── */}
    <div className="ft-top">
      <a href="/" className="ft-logo-link">
        <img src={logoImage} alt="Central Kia" className="ft-logo" />
      </a>
      <div className="ft-socials">
        {socials.map(({ label, env, icon }) => (
          <a
            key={label}
            href={process.env[env] || "#"}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={label}
            className="ft-social"
          >
            {icon}
          </a>
        ))}
      </div>
    </div>

    {/* ── LINK COLUMNS ── */}
    <div className="ft-cols">
      <div className="ft-col">
        <p className="ft-col__head">Menus</p>
        {menus.map(({ name, link }) => (
          <a key={name} href={link} className="ft-link">{name}</a>
        ))}
      </div>

      <div className="ft-col">
        <p className="ft-col__head">Cars</p>
        {cars.map(({ name, link }) => (
          <a key={name} href={link} className="ft-link">{name}</a>
        ))}
      </div>

      <div className="ft-col">
        <p className="ft-col__head">Forms</p>
        {forms.map(({ name, link }) => (
          <a key={name} href={link} className="ft-link">{name}</a>
        ))}
      </div>

      <div className="ft-col">
        <p className="ft-col__head">Service</p>
        {services.map(({ name, link }) => (
          <a key={name} href={link} className="ft-link">{name}</a>
        ))}
      </div>

      <div className="ft-col">
        <p className="ft-col__head">Legal</p>
        {legal.map(({ name, link }) => (
          <a key={name} href={link} className="ft-link">{name}</a>
        ))}
      </div>
    </div>

    {/* ── BOTTOM BAR ── */}
    <div className="ft-bottom">
      <div className="ft-bottom__left">
        <a href="/">
          <img src={centralLogo} alt="Central Group" className="ft-central-logo" />
        </a>
        <div className="ft-bottom__info">
          <p className="ft-bottom__contact">
            {process.env.REACT_APP_CONTACT_PHONE} &nbsp;·&nbsp; {process.env.REACT_APP_CONTACT_EMAIL}
          </p>
          <p className="ft-bottom__copy">
            © 2025 Central Kia by CONSORTIUM MOTORS PVT LTD. All Rights Reserved.
          </p>
          <p className="ft-bottom__dev">Designed & Developed by kliadvertising</p>
        </div>
      </div>
    </div>

  </footer>
);

export default Footer;